module.exports = __webpack_public_path__ + "static/media/me.52f118b3.jpg";